import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20silk%20fabric%20in%20soft%20coral%20peach%20and%20cream%20tones%2C%20gentle%20curves%20and%20waves%2C%20minimalist%20elegant%20background%2C%20soft%20diffused%20lighting%2C%20artistic%20texture%20with%20smooth%20gradients%2C%20calm%20and%20healing%20atmosphere%2C%20no%20sharp%20edges%2C%20dreamy%20ethereal%20quality%2C%20professional%20wellness%20aesthetic%2C%20high%20resolution%20editorial%20style&width=1800&height=800&seq=hero-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 text-center max-w-4xl mx-auto">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-6">
          专业·私密·温暖
          <br />
          <span className="text-primary-400">两性健康咨询服务</span>
        </h1>
        <p className="text-base md:text-lg text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
          由持证专业顾问团队提供一对一陪伴式咨询，涵盖性健康教育、亲密关系指导、性功能困扰解答等，
          帮助您重建自信与和谐的亲密生活。所有咨询严格保密，让您安心倾诉。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about#contact"
            className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-medium hover:bg-primary-600 transition-all duration-200"
          >
            预约免费初步评估
          </Link>
          <Link
            to="/category/xing-jian-kang-jiao-yu"
            className="whitespace-nowrap px-8 py-3.5 rounded-full border border-background-300/40 text-background-200 text-base font-medium hover:bg-background-50/10 transition-all duration-200"
          >
            了解我们的服务
          </Link>
        </div>

        <div className="grid grid-cols-3 gap-6 mt-16 max-w-2xl mx-auto">
          {[
            { number: '10,000+', label: '累计咨询服务' },
            { number: '98%', label: '用户满意度' },
            { number: '15年', label: '平均咨询经验' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-background-50">{stat.number}</p>
              <p className="text-sm text-background-300/80 mt-1">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}